import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/gamma/cdf';
import __var_2__ from '@stdlib/stats/base/dists/gamma/ctor';
import __var_3__ from '@stdlib/stats/base/dists/gamma/entropy';
import __var_4__ from '@stdlib/stats/base/dists/gamma/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/gamma/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/gamma/mean';
import __var_7__ from '@stdlib/stats/base/dists/gamma/mgf';
import __var_8__ from '@stdlib/stats/base/dists/gamma/mode';
import __var_9__ from '@stdlib/stats/base/dists/gamma/pdf';
import __var_10__ from '@stdlib/stats/base/dists/gamma/quantile';
import __var_11__ from '@stdlib/stats/base/dists/gamma/skewness';
import __var_12__ from '@stdlib/stats/base/dists/gamma/stdev';
import __var_13__ from '@stdlib/stats/base/dists/gamma/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace gamma
*/
var gamma = {};

/**
* @name cdf
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/cdf}
*/
setReadOnly( gamma, 'cdf', __var_1__);

/**
* @name Gamma
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/ctor}
*/
setReadOnly( gamma, 'Gamma', __var_2__);

/**
* @name entropy
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/entropy}
*/
setReadOnly( gamma, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/kurtosis}
*/
setReadOnly( gamma, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/logpdf}
*/
setReadOnly( gamma, 'logpdf', __var_5__);

/**
* @name mean
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/mean}
*/
setReadOnly( gamma, 'mean', __var_6__);

/**
* @name mgf
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/mgf}
*/
setReadOnly( gamma, 'mgf', __var_7__);

/**
* @name mode
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/mode}
*/
setReadOnly( gamma, 'mode', __var_8__);

/**
* @name pdf
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/pdf}
*/
setReadOnly( gamma, 'pdf', __var_9__);

/**
* @name quantile
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/quantile}
*/
setReadOnly( gamma, 'quantile', __var_10__);

/**
* @name skewness
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/skewness}
*/
setReadOnly( gamma, 'skewness', __var_11__);

/**
* @name stdev
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/stdev}
*/
setReadOnly( gamma, 'stdev', __var_12__);

/**
* @name variance
* @memberof gamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gamma/variance}
*/
setReadOnly( gamma, 'variance', __var_13__);


// EXPORTS //
export default gamma;

export { __var_1__ as cdf, __var_2__ as Gamma, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as mgf, __var_8__ as mode, __var_9__ as pdf, __var_10__ as quantile, __var_11__ as skewness, __var_12__ as stdev, __var_13__ as variance};